__turbopack_context__.v({
  "isOrderPage": "NavLanguageSwitcher-module-scss-module__0OWEoq__isOrderPage",
  "localeSwitchContainer": "NavLanguageSwitcher-module-scss-module__0OWEoq__localeSwitchContainer",
});
